export enum TitleAppearance {
	H3Regular = 'H3Regular',
	H4Bold = 'H4Bold',
	H5Bold = 'H5Bold',
	H5MediumGrey = 'H5MediumGrey',
}
